import type { PublicationCode } from '@/scopes/common/domain/models'

export function getShowRecommendedAccos(publicationCode: PublicationCode): boolean {
  return publicationCode === 'SZ'
}
